if (!customElements.get('media-gallery')) {
  // Fallback de debounce: en este tema `debounce` (secondary.js) a veces no esta
  // disponible cuando corre este script, y el constructor moria antes de enlazar
  // los eventos de las miniaturas (el tap dejaba de funcionar). Con esto el
  // constructor nunca falla por esa razon.
  var _mgDebounce = (typeof debounce === 'function')
    ? debounce
    : function (fn, wait) {
        var t;
        return function () {
          var ctx = this, args = arguments;
          clearTimeout(t);
          t = setTimeout(function () { fn.apply(ctx, args); }, wait || 0);
        };
      };

  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
      if (this.productInfo && Shopify.postLinksRetry) this.productInfo.initShareLinks();
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', _mgDebounce(this.onSlideChanged.bind(this), 500));
      this.bindThumbnailEvents();
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    // Delegación de eventos + detección real de TAP táctil.
    // SWIPE = desplaza el rail (no activa). TAP corto = selecciona la miniatura.
    // Sin preventDefault/stopPropagation: se conserva el scroll horizontal del
    // rail y el scroll vertical de la página.
    bindThumbnailEvents() {
      let pointerStartX = 0;
      let pointerStartY = 0;
      let pointerStartTime = 0;
      let pointerTarget = null;
      let touchHandledAt = 0;

      const getThumbnail = (target) => {
        if (!target || !target.closest) return null;

        const thumbnail = target.closest('[data-target]');
        if (!thumbnail || !this.elements.thumbnails.contains(thumbnail)) {
          return null;
        }

        return thumbnail;
      };

      const activateThumbnail = (thumbnail) => {
        if (!thumbnail) return;

        const mediaId = thumbnail.dataset.target;
        if (!mediaId) return;

        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );

        if (!activeMedia) {
          console.warn(
            '[MediaGallery] Media not found for thumbnail:',
            mediaId
          );
          return;
        }

        this.setActiveMedia(mediaId, false);
      };

      this.elements.thumbnails.addEventListener('pointerdown', (event) => {
        const thumbnail = getThumbnail(event.target);
        if (!thumbnail) return;

        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
        pointerStartTime = Date.now();
        pointerTarget = thumbnail;
      });

      this.elements.thumbnails.addEventListener('pointerup', (event) => {
        if (!pointerTarget) return;

        const thumbnail = getThumbnail(event.target);

        const distanceX = Math.abs(event.clientX - pointerStartX);
        const distanceY = Math.abs(event.clientY - pointerStartY);
        const elapsed = Date.now() - pointerStartTime;

        const isTap =
          thumbnail === pointerTarget &&
          distanceX < 12 &&
          distanceY < 12 &&
          elapsed < 600;

        pointerTarget = null;

        if (!isTap) return;

        if (
          event.pointerType === 'touch' ||
          event.pointerType === 'pen'
        ) {
          touchHandledAt = Date.now();
          activateThumbnail(thumbnail);
        }
      });

      this.elements.thumbnails.addEventListener('pointercancel', () => {
        pointerTarget = null;
      });

      this.elements.thumbnails.addEventListener('click', (event) => {
        const thumbnail = getThumbnail(event.target);
        if (!thumbnail) return;

        // Evita ejecutar dos veces despues de pointerup tactil.
        if (Date.now() - touchHandledAt < 500) {
          return;
        }

        activateThumbnail(thumbnail);
      });
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);

      if (!activeMedia) return;

      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          if (activeThumbnail) activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      const thumbnailButton = thumbnail.querySelector('button');
      if (thumbnailButton) thumbnailButton.setAttribute('aria-current', true);

      if (
        typeof this.elements.thumbnails.isSlideVisible === 'function' &&
        this.elements.thumbnails.isSlideVisible(thumbnail, 10)
      ) {
        return;
      }

      if (this.elements.thumbnails.slider) {
        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
          behavior: 'smooth'
        });
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image || !this.elements.liveRegion) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        const tpl = (window.accessibilityStrings && window.accessibilityStrings.imageAvailable) || '';
        if (tpl) this.elements.liveRegion.innerHTML = tpl.replace('[index]', position);
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      // `pauseAllMedia` lo define secondary.js; en este tema a veces no esta
      // disponible todavia y rompia setActiveMedia antes de actualizar aria-current.
      if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia && typeof deferredMedia.loadContent === 'function') deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
